import { render } from "./notification-comp.vue?vue&type=template&id=649f336d&scoped=true"
import script from "./notification-comp.vue?vue&type=script&lang=js"
export * from "./notification-comp.vue?vue&type=script&lang=js"

import "./notification-comp.vue?vue&type=style&index=0&id=649f336d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649f336d"]])

export default __exports__